import React from "react";
import { Dropdown, Form } from "semantic-ui-react";
import { exists } from "../../utils/utils";

const DropdownInput = ({
  selection,
  placeholder,
  label,
  options,
  defaultValue = "",
  meta: { error, touched },
  ...props
}) => {
  return (
    <Form.Field>
      {exists(label) ? <label>{label}</label> : null}
      <Dropdown
        selection={selection}
        placeholder={placeholder}
        options={options}
        value={props.input.value === "" ? defaultValue : props.input.value}
        onChange={(param, data) => props.input.onChange(data.value)}
        disabled={props.disabled}
        {...props}
      />
      {error && touched ? <span style={{ color: "red" }}>*{error}</span> : ""}
    </Form.Field>
  );
};

export default DropdownInput;
